module.exports = __webpack_public_path__ + "img/appareil-photo.f1c83fdb.svg";